import React from 'react';

// Estilo técnico padrão
const base = { stroke: "#000", strokeWidth: "1.5", fill: "#fff", strokeLinejoin: "round" as const };

// Definição dos pontos de conexão padrão (N, S, W, E)
const stdAnchors = [
  { id: 'n', x: 0.5, y: 0 }, { id: 's', x: 0.5, y: 1 },
  { id: 'w', x: 0, y: 0.5 }, { id: 'e', x: 1, y: 0.5 }
];

export const VSM_LIBRARY = {
  // --- GRUPO 1: PROCESSOS E ESTOQUE (Materiais) ---
  PROCESS: { 
    component: () => (
      <svg viewBox="0 0 120 60" width="120" height="60">
        <path d="M0 10 L12 0 L24 10 L36 0 L48 10 L60 0 L72 10 L84 0 L96 10 L108 0 L120 10 V60 H0 Z" {...base}/>
      </svg>
    ),
    anchors: stdAnchors,
    defaultSize: { width: 120, height: 60 }
  },
  INVENTORY: { 
    component: () => (
      <svg viewBox="0 0 40 40" width="40" height="40">
        <path d="M20 5 L36 34 H4 Z" {...base}/>
        <text x="20" y="27" textAnchor="middle" fontWeight="bold" fontSize="14" fill="#000">I</text>
      </svg>
    ),
    anchors: [{id:'n', x:0.5, y:0.1}, {id:'w', x:0.1, y:0.7}, {id:'e', x:0.9, y:0.7}, {id:'s', x:0.5, y:0.9}],
    defaultSize: { width: 40, height: 40 }
  },
  SUPERMARKET: { 
    component: () => (
      <svg viewBox="0 0 40 40" width="40" height="40">
        <path d="M10 5 H35 V35 H10" fill="none" stroke="#000" strokeWidth="2.5"/>
        <path d="M10 12 H25 M10 20 H25 M10 28 H25" stroke="#000" strokeWidth="1.5"/>
      </svg>
    ),
    anchors: [{id:'w', x:0.25, y:0.5}, {id:'e', x:0.85, y:0.5}, {id:'n', x:0.5, y:0.1}, {id:'s', x:0.5, y:0.9}],
    defaultSize: { width: 40, height: 40 }
  },
  EXTERNAL: { 
    component: () => (
      <svg viewBox="0 0 60 50" width="60" height="50">
        <path d="M0 50 V15 L12 5 L24 15 L36 5 L48 15 V10 H60 V50 Z" {...base}/>
      </svg>
    ),
    anchors: stdAnchors,
    defaultSize: { width: 60, height: 50 }
  },
  TRUCK: { 
    component: () => (
      <svg viewBox="0 0 50 30" width="50" height="30">
        <path d="M2 5 H35 V25 H2 Z M35 12 H48 V25 H35 Z" {...base}/>
        <circle cx="10" cy="25" r="3" fill="#000"/>
        <circle cx="42" cy="25" r="3" fill="#000"/>
      </svg>
    ),
    anchors: [{id:'w', x:0, y:0.5}, {id:'e', x:1, y:0.5}],
    defaultSize: { width: 35, height: 21 }
  },
  BUFFER: { 
    component: () => (
      <svg viewBox="0 0 40 30" width="40" height="30">
        <rect x="5" y="5" width="30" height="20" rx="10" {...base}/>
      </svg>
    ),
    anchors: stdAnchors,
    defaultSize: { width: 40, height: 30 }
  },

  // --- GRUPO 2: INFORMAÇÃO ---
  MANUAL_INFO: { 
    component: () => (
      <svg viewBox="0 0 40 20" width="40" height="20">
        <path d="M0 10 H35 L30 5 M35 10 L30 15" fill="none" stroke="#000" strokeWidth="1.5"/>
      </svg>
    ),
    anchors: [{id:'w', x:0, y:0.5}, {id:'e', x:1, y:0.5}],
    defaultSize: { width: 40, height: 20 }
  },
  ELEC_INFO: { 
    component: () => (
      <svg viewBox="0 0 40 30" width="40" height="30">
        <path d="M0 25 L12 5 L20 20 L35 0 L30 5 M35 0 L40 10" fill="none" stroke="#000" strokeWidth="1.5"/>
      </svg>
    ),
    anchors: [{id:'start', x:0, y:0.8}, {id:'end', x:1, y:0}],
    defaultSize: { width: 40, height: 30 }
  },
  KANBAN_PROD: { 
    component: () => (
      <svg viewBox="0 0 40 25" width="40" height="25">
        <rect x="2" y="2" width="36" height="21" {...base}/>
        <path d="M2 12 H38" stroke="#000" strokeWidth="1"/>
      </svg>
    ),
    anchors: stdAnchors,
    defaultSize: { width: 40, height: 25 }
  },
  KANBAN_WITHDRAWAL: { 
    component: () => (
      <svg viewBox="0 0 40 25" width="40" height="25">
        <rect x="2" y="2" width="36" height="21" fill="#ccc" stroke="#000" strokeWidth="1.5"/>
        <path d="M20 2 V23" stroke="#000" strokeWidth="1"/>
      </svg>
    ),
    anchors: stdAnchors,
    defaultSize: { width: 40, height: 25 }
  },
  SIGNAL_KANBAN: { 
    component: () => (
      <svg viewBox="0 0 40 25" width="40" height="25">
        <path d="M20 2 L36 23 H4 Z" {...base}/>
      </svg>
    ),
    anchors: stdAnchors,
    defaultSize: { width: 40, height: 25 }
  },
  HEIJUNKA: { 
    component: () => (
      <svg viewBox="0 0 40 30" width="40" height="30">
        <rect x="2" y="2" width="36" height="26" {...base}/>
        <path d="M2 10 H38 M2 20 H38 M12 2 V28 M25 2 V28" stroke="#000" strokeWidth="1"/>
      </svg>
    ),
    anchors: stdAnchors,
    defaultSize: { width: 40, height: 30 }
  },
  GO_SEE: { 
    component: () => (
      <svg viewBox="0 0 40 30" width="40" height="30">
        <circle cx="12" cy="15" r="8" {...base}/>
        <circle cx="28" cy="15" r="8" {...base}/>
        <circle cx="12" cy="15" r="3" fill="#000"/>
        <circle cx="28" cy="15" r="3" fill="#000"/>
      </svg>
    ),
    anchors: stdAnchors,
    defaultSize: { width: 40, height: 30 }
  },

  // --- GRUPO 3: KAIZEN E QUALIDADE ---
  KAIZEN: { 
    component: () => (
      <svg viewBox="0 0 40 40" width="40" height="40">
        <path d="M20 2 L24 12 L36 8 L30 18 L40 24 L28 26 L32 38 L22 30 L14 38 L18 26 L4 28 L12 20 L2 12 L14 14 Z" {...base}/>
      </svg>
    ),
    anchors: stdAnchors,
    defaultSize: { width: 40, height: 40 }
  },
  QUALITY: { 
    component: () => (
      <svg viewBox="0 0 40 40" width="40" height="40">
        <path d="M20 2 L36 20 L20 38 L4 20 Z" {...base}/>
        <text x="20" y="25" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#000">Q</text>
      </svg>
    ),
    anchors: stdAnchors,
    defaultSize: { width: 40, height: 40 }
  },
  SAFETY: { 
    component: () => (
      <svg viewBox="0 0 40 40" width="40" height="40">
        <path d="M15 5 H25 V15 H35 V25 H25 V35 H15 V25 H5 V15 H15 Z" {...base}/>
      </svg>
    ),
    anchors: stdAnchors,
    defaultSize: { width: 40, height: 40 }
  },
  OPERATOR: { 
    component: () => (
      <svg viewBox="0 0 40 40" width="40" height="40">
        <circle cx="20" cy="10" r="7" {...base}/>
        <path d="M5 38 C5 20, 35 20, 35 38" {...base}/>
      </svg>
    ),
    anchors: [{id:'c', x:0.5, y:0.5}],
    defaultSize: { width: 40, height: 40 }
  },
  CELL: { 
    component: () => (
      <svg viewBox="0 0 50 40" width="50" height="40">
        <path d="M40 5 H10 V35 H40" fill="none" stroke="#000" strokeWidth="3" strokeLinecap="round"/>
      </svg>
    ),
    anchors: stdAnchors,
    defaultSize: { width: 50, height: 40 }
  },
  FIFO: { 
    component: () => (
      <svg viewBox="0 0 60 20" width="60" height="20">
        <path d="M0 5 H60 M0 15 H60" stroke="#000" strokeWidth="1.5"/>
        <path d="M5 5 L15 15 M25 5 L35 15 M45 5 L55 15" stroke="#000" strokeWidth="1" opacity="0.5"/>
      </svg>
    ),
    anchors: [{id:'w', x:0, y:0.5}, {id:'e', x:1, y:0.5}],
    defaultSize: { width: 60, height: 20 }
  },
  PUSH_ARROW: { 
    component: () => (
      <svg viewBox="0 0 60 30" width="60" height="30">
        <defs>
          <pattern id="h-library" width="4" height="4" patternUnits="userSpaceOnUse">
            <path d="M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2" stroke="#000" strokeWidth="0.5"/>
          </pattern>
        </defs>
        <path d="M0 10 H40 V0 L60 15 L40 30 V20 H0 Z" fill="url(#h-library)" stroke="#000" strokeWidth="1.5"/>
      </svg>
    ),
    anchors: [{id:'w', x:0, y:0.5}, {id:'e', x:1, y:0.5}],
    defaultSize: { width: 60, height: 30 }
  },
  PULL_ARROW: { 
    component: () => (
      <svg viewBox="0 0 60 30" width="60" height="30">
        <path d="M60 15 L40 0 V10 H0 V20 H40 V30 Z" {...base}/>
      </svg>
    ),
    anchors: [{id:'w', x:0, y:0.5}, {id:'e', x:1, y:0.5}],
    defaultSize: { width: 60, height: 30 }
  }
};
